import { beHttp } from './beHttp';

/**
 * "Resumen del paciente" (tab Historia Clínica) — síntesis por IA de los mismos
 * registros que ya devuelve `apiCoreAdapter.getPatientSessionNotes` (mismo dato,
 * misma validación de acceso). Ver `patient-summary.prompt.ts` en psiplatform-be
 * para el criterio de generación (grounding estricto, riesgo nunca omitido).
 *
 * GET solo lee el estado cacheado (no llama a IA). POST fuerza una generación
 * nueva — es una acción explícita de la psicóloga (botón "Generar"/"Regenerar"),
 * nunca automática.
 */

export interface PatientSummarySections {
  motivoConsulta: string[];
  evolucionProceso: string[];
  estadoActual: string[];
  riesgosYRecursos: string[];
  pendientesContinuidad: string[];
}

export interface PatientSummary {
  sections: PatientSummarySections;
  disclaimer: string;
  generatedAt: string;
  noteCount: number;
  periodoDesde: string | null;
  periodoHasta: string | null;
}

/**
 * Deliberadamente NO trae `isStale`/`canGenerate`: calcularlos en el backend
 * requeriría releer las notas cross-proceso (mismo costo que ya paga el tab
 * al cargar la lista) en cada apertura. El componente que consume esto ya
 * tiene esas notas en memoria — compara `summary.noteCount`/`periodoHasta`
 * contra eso mismo. Ver PatientsService.getSummaryState (psiplatform-be).
 */
export interface PatientSummaryState {
  summary: PatientSummary | null;
}

export async function getPatientSummaryState(processId: string): Promise<PatientSummaryState> {
  return beHttp.get<PatientSummaryState>(
    `/api/psychologist/patients/${encodeURIComponent(processId)}/summary`,
    undefined,
    { showErrorToast: false },
  );
}

export async function generatePatientSummary(processId: string): Promise<PatientSummary> {
  return beHttp.post<PatientSummary>(
    `/api/psychologist/patients/${encodeURIComponent(processId)}/summary/generate`,
    undefined,
    {
      errorMessage: 'No se pudo generar el resumen',
      showErrorToast: false,
    },
  );
}
